import { satc_periodDetailsPayments } from "Constants/TableColumns";
import addNumToList from "Helpers/addNumToList";
import RemoteTable from "Components/RemoteTable/RemoteTable";

export default function PeriodDetailsPayments({ data }) {
  return (
    <RemoteTable
      data={addNumToList(data, 1, 0)}
      columns={satc_periodDetailsPayments}
      noTitle={true}
      showPagination={false}
    />
  );
}